import { createContext } from 'react';
import { getTeams } from '@tsClient/my';
import * as ApiModels from '@typings/api-models';
import { Team, TeamOwner } from './constants';

type TeamsContextType = {
  hasFetchedTeams: boolean;
  setCurrentTeam: (newTeam: Team | null) => void;
  creatorId: string | null;
  currentTeam: Team | null;
  currentTeamOwner: TeamOwner | null;
  refetchTeams: () => Promise<Awaited<ReturnType<typeof getTeams>>['items']>,
  setTeamUserId: (id: string) => void;
  teams: Team[];
  teamUserId: string | null;
  role: Omit<ApiModels.TeamMemberRoles, 'id' | 'teamMemberId'>;
};

/**
 * I at least am confused by what is provided by this context.
 * creatorId - The creator.id of the selected team
 * currentTeamOwner - The currently selected creator
 * currentTeam - The current users TeamMember for the selected creator. Ie { id: teamMemberId, role: Role, teamOwner: creator }
 *
 * So creatorId === currentTeamOwner.id === currentTeam.teamOwner.id
 */

const TeamsContext = createContext<TeamsContextType>({
  creatorId: null,
  currentTeam: null,
  currentTeamOwner: null,
  hasFetchedTeams: false,
  refetchTeams: async () => [],
  role:{
    admin: false,
    finance: false,
    manageTeam: false,
    role: "caseWorker",
  },
  setCurrentTeam: () => undefined,
  setTeamUserId: () => undefined,
  teamUserId: null,
  teams: [],
});

export default TeamsContext;
